export const TransferItem: React.FC<{
  title: string;
  isNewlyMoved: boolean;
}> = ({ title, isNewlyMoved }) => {
  const textSpan = (
    <div
      style={{
        display: 'flex',
        backgroundColor: isNewlyMoved ? '#e6f7ff' : 'transparent',
        maxWidth: '100%',
      }}
    >
      <span
        style={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          display: 'inline-block',
          maxWidth: '100%',
        }}
      >
        {title}
      </span>
    </div>
  );

  return <div>{textSpan}</div>;
};
